<template>
  <div class="main">
    <div class="main-slide">
      <div
        v-for="(item, index) in slideNav"
        :class="parName !== item.id ? 'main-slide-box' : index === 0 ? ['main-slide-box', 'active-top-box'] : ['main-slide-box', 'active-box']"
        :key="item.id"
        @click="changeContent(item)"
      >
        {{ item.name }}
        <i class="el-icon-question" v-if="item.isIcon" @click="showLegend()"></i>
      </div>
    </div>
    <div class="main-content">
      <component :is="parName"></component>
    </div>
    <div class="mask" v-if="showPop">
      <div class="legend-pop">
        <div class="legend-pop-title">
          <div class="legend-pop-msg">
            兑换说明
          </div>
          <div class="legend-pop-close" @click="closeLegend()">X</div>
        </div>
        <div class="legend-pop-common">
          <p>1.兑换的周边，成功提交邮寄地址后，将在15个工作日内安排发出，请耐心等待</p>
          <p>2.如需咨询，请联系官方微信客服</p>
        </div>
        <div class="legend-pop-btn" @click="closeLegend()">
          返回
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Coupons from './couponModule/coupons.vue'
import HistoryCoupons from './couponModule/historyCoupons.vue'
import DailyBenefits from './couponModule/dailyBenefits.vue'
import PointsDetails from './usercenterModule/pointsDetails.vue'
import UserInformation from './usercenterModule/userInformation.vue'
import ExchangeRecord from './pointsModule/exchangeRecord.vue'
import Redeem from './pointsModule/redeem.vue'

export default {
  name: 'TotalModule',
  props: {
    slideNav: {
      type: Array,
      default: () => {}
    }
  },
  data() {
    return {
      parName: null,
      showPop: false
    }
  },
  components: {
    Coupons,
    HistoryCoupons,
    DailyBenefits,
    PointsDetails,
    UserInformation,
    ExchangeRecord,
    Redeem,
  },
  watch: {
    slideNav: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.parName = newVal.filter((item, index) => index === 0)[0]['id']
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
  },
  methods: {
    changeContent(data) {
      this.parName = data.id
      // console.log(this.comName, data);
    },
    showLegend() {
      this.showPop = true
    },
    closeLegend() {
      this.showPop = false
    }
  },
};
</script>
<style lang="less" scoped>
.main {
  max-width: 1200px;
  height: 565px;
  overflow: auto;
  margin: 0 auto;
  margin-top: 20px;
  display: flex;
  justify-content: flex-start;
  background: #fff;
  .main-slide {
    width: 180px;
    border-right: 1px solid #dddddd;
    position: relative;
    box-sizing: border-box;
    .main-slide-box {
      width: 100%;
      text-align: left;
      padding-left: 30px;
      line-height: 40px;
      font-size: 14px;
      color: #565656;
      box-sizing: border-box;
      cursor: pointer;
    }
    .active-top-box {
      width: 180px;
      position: relative;
      font-size: 18px;
      color: #f2b367;
      text-decoration: underline;
      z-index: 1;
      border-bottom: 1px solid #dddddd;
      border-right: 1px solid #fff;
    }
    .active-box {
      width: 180px;
      position: relative;
      font-size: 18px;
      color: #f2b367;
      text-decoration: underline;
      z-index: 1;
      border-bottom: 1px solid #dddddd;
      border-top: 1px solid #dddddd;
      border-right: 1px solid #fff;
    }
  }
  .main-content {
    flex: 1;
    /deep/ ::-webkit-scrollbar {
      display:none
    }
  }
  .mask {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.7);
    z-index: 999;
    .legend-pop {
      width: 435px;
      height: 315px;
      background: #fff;
      position: absolute;
      left: 50%;
      top: 25%;
      transform: translateX(-50%);
      background: #fff;
      animation: showDialog 0.5s;
      animation-timing-function: cubic-bezier(0.6,0,0.4,1);
      .legend-pop-title {
        height: 48px;
        width: 100%;
        background: #ec6c04;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding-right: 20px;
        box-sizing: border-box;
        .legend-pop-msg {
          flex: 1;
          line-height: 48px;
          font-size: 20px;
          color: #fff;
          font-weight: bold;
          text-align: center;
        }
        .legend-pop-close {
          font-size: 16px;
          font-weight: bold;
          color: #fff;
          cursor: pointer;
        }
      }
      .legend-pop-common {
        width: 295px;
        margin: 0 auto;
        overflow: hidden;
        margin-top: 10px;
        p {
          width: 100%;
          font-size: 14px;
          color: #6a6a6a;
          margin-top: 35px;
          text-align: left;
        }
      }
      .legend-pop-btn {
        width: 233px;
        height: 50px;
        background: #ec6c04;
        text-align: center;
        line-height: 50px;
        font-size: 20px;
        font-weight: bold;
        color: #fff;
        cursor: pointer;
        margin: 0 auto;
        margin-top: 45px;
      }
    }
  }
}
@keyframes showDialog {
  0% {
    opacity: 0;
    left: 50%;
    transform: scale3d(0, 0, 0), translateX(-50%);
  }
  100% {
    opacity: 1;
    left: 50%;
    transform: scale3d(1, 1, 1), translateX(-50%);
  }
}
</style>